<template>
  <div>
    <AboutList :tableData="tableData" name="取消收藏" @isCollect='isCollect' @init='init'/>
  </div>
</template>

<script>
import { reqMyCorpColl, reqCorpCollDo } from "../../../../api";
import AboutList from "../../../../components/pc/aboutList";
export default {
  components:{
    AboutList
  },
  data(){
    return{
      tableData:{
        listnum: 0,
        pagelistnum: 0,
        prompt:"确定要取消收藏吗？",
        list:[ ]
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(p=1){
      const response = await reqMyCorpColl(p)
      if (response.code*1==2) {//请求成功
        this.tableData={
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          list:response.reslist
        }
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"登录失效，请重新登录")
      }else if (response.code*1==1) {//未收藏
      }
    },
    async isCollect(ocid){
      // 修改收藏状态
      const response = await reqCorpCollDo(ocid)
      if (response.code==0) {
        // this.collect=response.is_coll
        let index = this.tableData.list.findIndex(item=>item.ocid==ocid)
        if (index>=0) this.tableData.list.splice(index,1)
        this.success(this,'取消收藏成功！')
      }else{
        this.err(this,'请求失败，请重新尝试。。。')
      }
    },
  }
}
</script>

<style>

</style>